import { AufemininContentTypeName } from "../../../../../../config/AUFEMININ/contentTypes/ContentTypeName";
import { Fields } from "../../../../../../config/FieldNames";
var SECTION_HOME_CHUNK_CONTENT_TYPE_NAMES = [AufemininContentTypeName.SectionHomeES, AufemininContentTypeName.SectionHomeFR];
export { SECTION_HOME_CHUNK_CONTENT_TYPE_NAMES as SECTION_HOME_CHUNK_CONTENT_TYPE_NAMES_AUFEMININ };